const DocsBlockquotePage = () => import('@views/docs/DocsBlockquotePage')

export default {
  path: 'blockquote',
  name: 'DocsBlockquotePage',
  component: DocsBlockquotePage,
}
